import React from 'react';
import { GlobalStyle } from '@prima-afp/prima-ui-elements/dist/layouts';

import { MinimumPensionEstimatorAppRouter } from './router';

const MinimumPensionEstimatorApp = () => {
  return (
    <GlobalStyle>
      <MinimumPensionEstimatorAppRouter />
    </GlobalStyle>
  );
};

export default MinimumPensionEstimatorApp;
